import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import s from './input.module.css';
const inputMargin = 4;
const additionsMargin = 8;
const padding = 16;
const Label = ({ container: container, size, content, info, reset, postfix, children, id, required, status, }) => {
    const [restrictions, setRestriction] = useState({ start: padding, end: padding });
    const getAdditions = useCallback(() => { var _a; return Array.from(((_a = container.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[data-addon-end]')) || []); }, [
        container,
    ]);
    useEffect(() => {
        if (size !== 'l') {
            return;
        }
        const additions = getAdditions();
        const width = additions.reduce((res, node) => res + node.offsetWidth, 0);
        const restriction = padding + width + ((additions.length - 1) * additionsMargin + Math.sign(additions.length) * inputMargin);
        setRestriction(prev => (Object.assign(Object.assign({}, prev), { end: restriction })));
    }, [status.icon, content.end, info, reset, size, postfix, getAdditions]);
    useEffect(() => {
        var _a, _b;
        if (size !== 'l') {
            return;
        }
        const width = ((_b = (_a = container.current) === null || _a === void 0 ? void 0 : _a.querySelector('[data-addon-start]')) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0;
        const restriction = padding + width;
        setRestriction(prev => (Object.assign(Object.assign({}, prev), { start: restriction })));
    }, [content.start, size, container]);
    return (React.createElement("label", { htmlFor: id, className: classNames(s.label, size === 'l' ? s.inside : s.outside, required && s.required), style: Object.assign({}, (size === 'l' && { left: restrictions.start, right: restrictions.end })) },
        React.createElement("span", { className: s.labeltext }, children),
        required && React.createElement("div", { className: s.star }, "*")));
};
export default Label;
//# sourceMappingURL=label.js.map